import { sendGridEndpointIds } from 'root/src/server/modules/mails/fixtures/sendGridEndpointIds.fixture';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const sendGridSyncEndpoint = {
    [sendGridEndpointIds.SEND_GRID_SYNC]: {
        payloadSchema: cronJobPayloadSchema,
    },
};
